var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-warp"},[_c('div',{staticClass:"loading-box"},[_c('div'),_c('h1',[_vm._v(_vm._s(_vm.titleText))]),(_vm.companyText)?_c('p',[_c('span',[_vm._v(_vm._s(_vm.companyText))])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }